export const TITULO = 'Títulos > ';
export const NOVO_TITULO = 'Novo Título';
export const INSPECIONAR = 'Inspecionar > ';
export const INCLUIR_TITULO = 'Inclusão de Título';
export const TITULO_PROTESTADO = 'Título Protestado:';
export const TITULO_EDITAR = 'Editar Título';
